/*=========================================================================================
  File Name: moduleRecueilMutations.js
  Description: Recueil Module Mutations
==========================================================================================*/


export default {
	SET_HASCHANGES(state, payload) {
		state.hasChanges = payload;
	},
	ADD_TO_HASCHANGES(state, payload) {
		var foundIndex = state.hasChanges.steps.findIndex(x => x == payload);
		if (foundIndex < 0)
			state.hasChanges.steps.push(payload);
	},
	REMOVE_FROM_HASCHANGES(state, payload) {
		var foundIndex = state.hasChanges.steps.findIndex(x => x == payload);
		if (foundIndex >= 0)
			state.hasChanges.steps.splice(foundIndex, 1);
	},
	SET_DOSSIERID(state, payload) {
		state.dossierId = payload;
	},
	SET_CLIENTID(state, payload) {
		state.clientId = payload;
	},
	SET_COMMENTAIREDOSSIER(state, payload) {
		state.commentaireDossier = payload;
	},
	SET_DERDOSSIER(state, payload) {
		state.derDossier = payload;
	},
	SET_CONFORMITE_ORIGINEFONDS(state, payload) {
		state.conformite.origineFonds = payload;
	},
	SET_CONFORMITE_OBJETRELATION(state, payload) {
		state.conformite.objetRelation = payload;
	},
	SET_CONFORMITE_COHERENCEPROFIL(state, payload) {
		state.conformite.coherenceProfil = payload;
	},
	SET_CONFORMITE_CLIENTPRESENTRDV(state, payload) {
		state.conformite.clientPresentRdv = payload;
	},
	SET_FISCALITE_IRPPACQUITTE(state, payload) {
		state.fiscalite.irppAcquitte = payload;
	},
	SET_FISCALITE_IFIACQUITTE(state, payload) {
		state.fiscalite.ifiAcquitte = payload;
	},
	SET_ETATCIVIL_FIRSTNAME(state, payload) {
		state.etatCivil.firstName = payload;
	},
	SET_ETATCIVIL_LASTNAME(state, payload) {
		state.etatCivil.lastName = payload;
	},
	SET_ETATCIVIL_BIRTHLASTNAME(state, payload) {
		state.etatCivil.birthLastName = payload;
	},
	SET_ETATCIVIL_CIVILITY(state, payload) {
		state.etatCivil.civility = payload;
	},
	SET_ETATCIVIL_DATEOFBIRTH(state, payload) {
		state.etatCivil.dateOfBirth = payload;
	},
	SET_ETATCIVIL_BIRTHCITY(state, payload) {
		state.etatCivil.birthCity = payload;
	},
	SET_ETATCIVIL_BIRTHSTATE(state, payload) {
		state.etatCivil.birthState = payload;
	},
	SET_ETATCIVIL_BIRTHDEPTNUM(state, payload) {
		state.etatCivil.birthDeptNum = payload;
	},
	SET_ETATCIVIL_BIRTHCOUNTRY(state, payload) {
		state.etatCivil.birthCountry = payload;
	},
	SET_ETATCIVIL_NATIONALITY(state, payload) {
		state.etatCivil.nationality = payload;
	},
	SET_ETATCIVIL_ISPARENTISOLE(state, payload) {
		state.etatCivil.isParentIsole = payload;
	},
	SET_ETATCIVIL_ISANCIENCOMBATTANT(state, payload) {
		state.etatCivil.isAncienCombattant = payload;
	},
	SET_ETATCIVIL_ISHANDICAPE(state, payload) {
		state.etatCivil.isHandicape = payload;
	},
	SET_CONJOINT_ETATCIVIL_ISANCIENCOMBATTANT(state, payload) {
		state.situationFamiliale.conjointEtatCivil.isAncienCombattant = payload;
	},
	SET_CONJOINT_ETATCIVIL_ISHANDICAPE(state, payload) {
		state.situationFamiliale.conjointEtatCivil.isHandicape = payload;
	},
	SET_CONTACTINFO_ADDRESS(state, payload) {
		state.contactInfo.address = payload;
	},
	SET_CONTACTINFO_ADDRESSCOMP(state, payload) {
		state.contactInfo.addressComp = payload;
	},
	SET_CONTACTINFO_ZIPCODE(state, payload) {
		state.contactInfo.zipCode = payload;
	},
	SET_CONTACTINFO_CITY(state, payload) {
		state.contactInfo.city = payload;
	},
	SET_CONTACTINFO_COUNTRY(state, payload) {
		state.contactInfo.country = payload;
	},
	SET_CONTACTINFO_PERSOEMAIL(state, payload) {
		state.contactInfo.persoEmail = payload;
	},
	SET_CONTACTINFO_PROEMAIL(state, payload) {
		state.contactInfo.proEmail = payload;
	},
	SET_CONTACTINFO_CELLPHONE(state, payload) {
		state.contactInfo.cellPhone = payload;
	},
	SET_CONTACTINFO_PROPHONE(state, payload) {
		state.contactInfo.proPhone = payload;
	},
	SET_CONTACTINFO_PERSOPHONE(state, payload) {
		state.contactInfo.persoPhone = payload;
	},
	SET_CONTACTINFO_CELLPHONEFORMATTED(state, payload) {
		state.contactInfo.cellPhoneFormatted = payload;
	},
	SET_CONTACTINFO_PROPHONEFORMATTED(state, payload) {
		state.contactInfo.proPhoneFormatted = payload;
	},
	SET_CONTACTINFO_PERSOPHONEFORMATTED(state, payload) {
		state.contactInfo.persoPhoneFormatted = payload;
	},
	SET_CONTACTINFO_CELLPHONECOUNTRYVAL(state, payload) {
		state.contactInfo.cellPhoneCountryVal = payload;
	},
	SET_CONTACTINFO_PROPHONECOUNTRYVAL(state, payload) {
		state.contactInfo.proPhoneCountryVal = payload;
	},
	SET_CONTACTINFO_PERSOPHONECOUNTRYVAL(state, payload) {
		state.contactInfo.persoPhoneCountryVal = payload;
	},
	SET_SITUATIONFAMILIALE_FAMSITUATION(state, payload) {
		state.situationFamiliale.famSituation = payload;
	},
	SET_SITUATIONFAMILIALE_REGIMEMATRIMONIAL(state, payload) {
		state.situationFamiliale.regimeMatrimonial = payload;
	},
	SET_SITUATIONFAMILIALE_REGIMEPACS(state, payload) {
		state.situationFamiliale.regimePacs = payload;
	},
	SET_SITUATIONFAMILIALE_HASREGIMEMATRIMONIAL(state, payload) {
		state.situationFamiliale.hasRegimeMatrimonial = payload;
	},
	SET_SITUATIONFAMILIALE_HASREGIMEPACS(state, payload) {
		state.situationFamiliale.hasRegimePacs = payload;
	},
	SET_SITUATIONFAMILIALE_HASCONJOINT(state, payload) {
		state.situationFamiliale.hasConjoint = payload;
	},
	SET_CONJOINT_CONTACTINFO_PERSOEMAIL(state, payload) {
		state.situationFamiliale.conjointContactInfo.persoEmail = payload;
	},
	SET_CONJOINT_CONTACTINFO_PROEMAIL(state, payload) {
		state.situationFamiliale.conjointContactInfo.proEmail = payload;
	},
	SET_CONJOINT_CONTACTINFO_CELLPHONE(state, payload) {
		state.situationFamiliale.conjointContactInfo.cellPhone = payload;
	},
	SET_CONJOINT_CONTACTINFO_PROPHONE(state, payload) {
		state.situationFamiliale.conjointContactInfo.proPhone = payload;
	},
	SET_CONJOINT_CONTACTINFO_PERSOPHONE(state, payload) {
		state.situationFamiliale.conjointContactInfo.persoPhone = payload;
	},
	SET_CONJOINT_CONTACTINFO_CELLPHONEFORMATTED(state, payload) {
		state.situationFamiliale.conjointContactInfo.cellPhoneFormatted = payload;
	},
	SET_CONJOINT_CONTACTINFO_PROPHONEFORMATTED(state, payload) {
		state.situationFamiliale.conjointContactInfo.proPhoneFormatted = payload;
	},
	SET_CONJOINT_CONTACTINFO_PERSOPHONEFORMATTED(state, payload) {
		state.situationFamiliale.conjointContactInfo.persoPhoneFormatted = payload;
	},	
	SET_CONJOINT_CONTACTINFO_CELLPHONECOUNTRYVAL(state, payload) {
		state.situationFamiliale.conjointContactInfo.cellPhoneCountryVal = payload;
	},
	SET_CONJOINT_CONTACTINFO_PROPHONECOUNTRYVAL(state, payload) {
		state.situationFamiliale.conjointContactInfo.proPhoneCountryVal = payload;
	},
	SET_CONJOINT_CONTACTINFO_PERSOPHONECOUNTRYVAL(state, payload) {
		state.situationFamiliale.conjointContactInfo.persoPhoneCountryVal = payload;
	},
	SET_CONJOINT_SOCIOPROCAT(state, payload) {
		state.situationFamiliale.conjointSituationProfessionnelle.socioProCat = payload;
	},
	SET_CONJOINT_PROFESSIONLIBELLE(state, payload) {
		state.situationFamiliale.conjointSituationProfessionnelle.libelle = payload;
	},
	SET_SOCIOPROCAT(state, payload) {
		state.situationProfessionnelle.socioProCat = payload;
	},
	SET_PROFESSIONLIBELLE(state, payload) {
		state.situationProfessionnelle.libelle = payload;
	},
	SET_CONJOINT_ETATCIVIL_FIRSTNAME(state, payload) {
		state.situationFamiliale.conjointEtatCivil.firstName = payload;
	},
	SET_CONJOINT_ETATCIVIL_LASTNAME(state, payload) {
		state.situationFamiliale.conjointEtatCivil.lastName = payload;
	},
	SET_CONJOINT_ETATCIVIL_BIRTHLASTNAME(state, payload) {
		state.situationFamiliale.conjointEtatCivil.birthLastName = payload;
	},
	SET_CONJOINT_ETATCIVIL_CIVILITY(state, payload) {
		if (payload == "")
			payload = null;
		state.situationFamiliale.conjointEtatCivil.civility = payload;
	},
	SET_CONJOINT_ETATCIVIL_DATEOFBIRTH(state, payload) {
		state.situationFamiliale.conjointEtatCivil.dateOfBirth = payload;
	},
	SET_CONJOINT_ETATCIVIL_BIRTHCITY(state, payload) {
		state.situationFamiliale.conjointEtatCivil.birthCity = payload;
	},
	SET_CONJOINT_ETATCIVIL_BIRTHSTATE(state, payload) {
		state.situationFamiliale.conjointEtatCivil.birthState = payload;
	},
	SET_CONJOINT_ETATCIVIL_BIRTHDEPTNUM(state, payload) {
		state.situationFamiliale.conjointEtatCivil.birthDeptNum = payload;
	},
	SET_CONJOINT_ETATCIVIL_BIRTHCOUNTRY(state, payload) {
		state.situationFamiliale.conjointEtatCivil.birthCountry = payload;
	},
	SET_CONJOINT_ETATCIVIL_NATIONALITY(state, payload) {
		state.situationFamiliale.conjointEtatCivil.nationality = payload;
	},
	SET_AVANTAGESMATRIMONIAUX_ATTRIBUTIONBIENSCOMMUNS(state, payload) {
		state.avantagesMatrimoniaux.attributionBiensCommuns = payload;
	},
	SET_AVANTAGESMATRIMONIAUX_AUPROFITCLIENTASSURANCENONDENOUEES(state, payload) {
		state.avantagesMatrimoniaux.auProfitClientAssuranceNonDenouees = payload;
	},
	SET_AVANTAGESMATRIMONIAUX_AUPROFITCONJOINTASSURANCENONDENOUEES(state, payload) {
		state.avantagesMatrimoniaux.auProfitConjointAssuranceNonDenouees = payload;
	},
	SET_AVANTAGESMATRIMONIAUX_MONTANTAUPROFITCLIENTASSURANCENONDENOUEES(state, payload) {
		state.avantagesMatrimoniaux.montantAuProfitClientAssuranceNonDenouees = payload;
	},
	SET_AVANTAGESMATRIMONIAUX_MONTANTAUPROFITCONJOINTASSURANCENONDENOUEES(state, payload) {
		state.avantagesMatrimoniaux.montantAuProfitConjointAssuranceNonDenouees = payload;
	},
	SET_AVANTAGESMATRIMONIAUX_AUTRESBIENSCLIENT(state, payload) {
		state.avantagesMatrimoniaux.autresBiensClient = payload;
	},
	SET_AVANTAGESMATRIMONIAUX_AUTRESBIENSCONJOINT(state, payload) {
		state.avantagesMatrimoniaux.autresBiensConjoint = payload;
	},
	SET_AVANTAGESMATRIMONIAUX_AVANTAGESMATRIMONIAUXCOMMENTAIRES(state, payload) {
		state.avantagesMatrimoniaux.avantagesMatrimoniauxCommentaires = payload;
	},
	SET_AVANTAGESMATRIMONIAUX_ISCLAUSEPRECIPUTAUPROFITCLIENT(state, payload) {
		state.avantagesMatrimoniaux.isClausePreciputAuProfitClient = payload;
	},
	SET_AVANTAGESMATRIMONIAUX_ISCLAUSEPRECIPUTAUPROFITCONJOINT(state, payload) {
		state.avantagesMatrimoniaux.isClausePreciputAuProfitConjoint = payload;
	},
	SET_AVANTAGESMATRIMONIAUX_AUPROFITCLIENTDONATIONDERNIERVIVANT(state, payload) {
		state.avantagesMatrimoniaux.auProfitClientDonationDernierVivant = payload;
	},
	SET_AVANTAGESMATRIMONIAUX_AUPROFITCONJOINTDONATIONDERNIERVIVANT(state, payload) {
		state.avantagesMatrimoniaux.auProfitConjointDonationDernierVivant = payload;
	},
	SET_AVANTAGESMATRIMONIAUX_AUPROFITCLIENTDONATIONSENTREVIFS(state, payload) {
		state.avantagesMatrimoniaux.auProfitClientDonationsEntreVifs = payload;
	},
	SET_AVANTAGESMATRIMONIAUX_AUPROFITCONJOINTDONATIONSENTREVIFS(state, payload) {
		state.avantagesMatrimoniaux.auProfitConjointDonationsEntreVifs = payload;
	},
	SET_AVANTAGESMATRIMONIAUX_DUESPARCLIENTBENEFICECOMMUNAUTE(state, payload) {
		state.avantagesMatrimoniaux.duesParClientBeneficeCommunaute = payload;
	},
	SET_AVANTAGESMATRIMONIAUX_DUESPARCONJOINTBENEFICECOMMUNAUTE(state, payload) {
		state.avantagesMatrimoniaux.duesParConjointBeneficeCommunaute = payload;
	},
	SET_AVANTAGESMATRIMONIAUX_DUESPARCOMMUNAUTEAUCLIENT(state, payload) {
		state.avantagesMatrimoniaux.duesParCommunauteAuClient = payload;
	},
	SET_AVANTAGESMATRIMONIAUX_DUESPARCOMMUNAUTEAUCONJOINT(state, payload) {
		state.avantagesMatrimoniaux.duesParCommunauteAuConjoint = payload;
	},
	SET_AVANTAGESMATRIMONIAUX_AUPROFITCLIENTDONATIONANTERIEUR(state, payload) {
		state.avantagesMatrimoniaux.auProfitClientDonationAnterieur = payload;
	},
	SET_AVANTAGESMATRIMONIAUX_AUPROFITCONJOINTDONATIONANTERIEUR(state, payload) {
		state.avantagesMatrimoniaux.auProfitConjointDonationAnterieur = payload;
	},
	SET_AVANTAGESMATRIMONIAUX_AUPROFITCLIENTLEGS(state, payload) {
		state.avantagesMatrimoniaux.auProfitClientLegs = payload;
	},
	SET_AVANTAGESMATRIMONIAUX_AUPROFITCLIENTLEGSMONTANT(state, payload) {
		state.avantagesMatrimoniaux.auProfitClientLegsMontant = payload;
	},
	SET_AVANTAGESMATRIMONIAUX_AUPROFITCLIENTLEGSUSURFRUIT(state, payload) {
		state.avantagesMatrimoniaux.auProfitClientLegsUsurfruit = payload;
	},
	SET_AVANTAGESMATRIMONIAUX_AUPROFITCONJOINTLEGS(state, payload) {
		state.avantagesMatrimoniaux.auProfitConjointLegs = payload;
	},
	SET_AVANTAGESMATRIMONIAUX_AUPROFITCONJOINTLEGSMONTANT(state, payload) {
		state.avantagesMatrimoniaux.auProfitConjointLegsMontant = payload;
	},
	SET_AVANTAGESMATRIMONIAUX_AUPROFITCONJOINTLEGSUSURFRUIT(state, payload) {
		state.avantagesMatrimoniaux.auProfitConjointLegsUsurfruit = payload;
	},
	SET_AVANTAGESMATRIMONIAUX_DETTESCLIENTENVERSCONJOINT(state, payload) {
		state.avantagesMatrimoniaux.dettesClientEnversConjoint = payload;
	},
	SET_AVANTAGESMATRIMONIAUX_DETTESCONJOINTENVERSCLIENT(state, payload) {
		state.avantagesMatrimoniaux.dettesConjointEnversClient = payload;
	},
	SET_AVANTAGESMATRIMONIAUX_AUPROFITCLIENTCREANCEPARTICIPATION(state, payload) {
		state.avantagesMatrimoniaux.auProfitClientCreanceParticipation = payload;
	},
	SET_AVANTAGESMATRIMONIAUX_AUPROFITCONJOINTCREANCEPARTICIPATION(state, payload) {
		state.avantagesMatrimoniaux.auProfitConjointCreanceParticipation = payload;
	},
	SET_HERITIERS(state, payload) {
		state.heritiers = payload;
	},
	ADD_TO_HERITIERS(state, payload) {
		state.heritiers.push(payload);
	},
	REMOVE_FROM_HERITIERS(state, payload) {
		state.heritiers.splice(payload, 1);
	},
	EDIT_HERITIER(state, payload) {
		state.heritiers.splice(payload.index, 1, payload.item);
	},
	EDIT_ACTIF(state, payload) {
		state.actifs.splice(payload.index, 1, payload.item);
	},
	EDIT_PASSIF(state, payload) {
		state.passifs.splice(payload.index, 1, payload.item);
	},
	EDIT_CHARGE(state, payload) {
		state.charges.splice(payload.index, 1, payload.item);
	},
	EDIT_REVENU(state, payload) {
		state.revenus.splice(payload.index, 1, payload.item);
	},
	EDIT_LIBERALITE(state, payload) {
		state.liberalites.splice(payload.index, 1, payload.item);
	},
	SET_LIBERALITES(state, payload) {
		state.liberalites = payload;
	},
	ADD_TO_LIBERALITES(state, payload) {
		state.liberalites.push(payload);
	},
	REMOVE_FROM_LIBERALITES(state, payload) {
		state.liberalites.splice(payload, 1);
	},
	SET_ACTIFS(state, payload) {
		state.actifs = payload;
	},
	ADD_TO_ACTIFS(state, payload) {
		state.actifs.push(payload);
	},
	REMOVE_FROM_ACTIFS(state, payload) {
		state.actifs.splice(payload, 1);
	},
	SET_PASSIFS(state, payload) {
		state.passifs = payload;
	},
	ADD_TO_PASSIFS(state, payload) {
		state.passifs.push(payload);
	},
	REMOVE_FROM_PASSIFS(state, payload) {
		state.passifs.splice(payload, 1);
	},
	SET_REVENUS(state, payload) {
		state.revenus = payload;
	},
	ADD_TO_REVENUS(state, payload) {
		state.revenus.push(payload);
	},
	REMOVE_FROM_REVENUS(state, payload) {
		state.revenus.splice(payload, 1);
	},
	SET_OBJECTIFS(state, payload) {
		state.objectifs = payload;
	},
	ADD_TO_OBJECTIFS(state, payload) {
		state.objectifs.push(payload);
	},
	REMOVE_FROM_OBJECTIFS(state, payload) {
		state.objectifs.splice(payload, 1);
	},
	SET_CHARGES(state, payload) {
		state.charges = payload;
	},
	ADD_TO_CHARGES(state, payload) {
		state.charges.push(payload);
	},
	REMOVE_FROM_CHARGES(state, payload) {
		state.charges.splice(payload, 1);
	},
	SET_PREVOYANCE_DECES(state, payload) {
		state.prevoyance.deces = payload;
	},
	ADD_TO_PREVOYANCE_DECES(state, payload) {
		var foundIndex = state.prevoyance.deces.findIndex(x => x.id == payload.id);
		if (foundIndex && foundIndex >= 0){
			state.prevoyance.deces[foundIndex].value = payload.value;
			state.prevoyance.deces[foundIndex].catId = payload.catId;
		}
		else {
			state.prevoyance.deces.push(payload);
		}
	},
	REMOVE_FROM_PREVOYANCE_DECES(state, payload) {
		state.prevoyance.deces.splice(payload, 1);
	},
	SET_PREVOYANCE_INCAPACITETEMP(state, payload) {
		state.prevoyance.incapaciteTemp = payload;
	},
	ADD_TO_PREVOYANCE_INCAPACITETEMP(state, payload) {
		var foundIndex = state.prevoyance.incapaciteTemp.findIndex(x => x.id == payload.id);
		if (foundIndex >= 0) {
			state.prevoyance.incapaciteTemp[foundIndex] = payload;
		} else {
			state.prevoyance.incapaciteTemp.push(payload);
		}
	},
	REMOVE_FROM_PREVOYANCE_INCAPACITETEMP(state, payload) {
		state.prevoyance.incapaciteTemp.splice(payload, 1);
	},
	SET_PREVOYANCE_TYPECLIENTINDIVINCAPACITETEMP(state, payload) {
		state.prevoyance.typeClientIndivIncapaciteTemp = payload;
	},
	SET_PREVOYANCE_TYPECLIENTCOLLECTIFINCAPACITETEMP(state, payload) {
		state.prevoyance.typeClientCollectifIncapaciteTemp = payload;
	},
	SET_PREVOYANCE_TYPECONJOINTINDIVINCAPACITETEMP(state, payload) {
		state.prevoyance.typeConjointIndivIncapaciteTemp = payload;
	},
	SET_PREVOYANCE_TYPECONJOINTCOLLECTIFINCAPACITETEMP(state, payload) {
		state.prevoyance.typeConjointCollectifIncapaciteTemp = payload;
	},
	SET_PREVOYANCE_INCAPACITEPERM(state, payload) {
		state.prevoyance.incapacitePerm = payload;
	},
	ADD_TO_PREVOYANCE_INCAPACITEPERM(state, payload) {
		var foundIndex = state.prevoyance.incapacitePerm.findIndex(x => x.id == payload.id);
		if (foundIndex >= 0) {
			state.prevoyance.incapacitePerm[foundIndex] = payload;
		} else {
			state.prevoyance.incapacitePerm.push(payload);
		}
	},
	REMOVE_FROM_PREVOYANCE_INCAPACITEPERM(state, payload) {
		state.prevoyance.incapacitePerm.splice(payload, 1);
	},
	SET_PREVOYANCE_TYPECLIENTINDIVINCAPACITEPERM(state, payload) {
		state.prevoyance.typeClientIndivIncapacitePerm = payload;
	},
	SET_PREVOYANCE_TYPECLIENTCOLLECTIFINCAPACITEPERM(state, payload) {
		state.prevoyance.typeClientCollectifIncapacitePerm = payload;
	},
	SET_PREVOYANCE_TYPECONJOINTINDIVINCAPACITEPERM(state, payload) {
		state.prevoyance.typeConjointIndivIncapacitePerm = payload;
	},
	SET_PREVOYANCE_TYPECONJOINTCOLLECTIFINCAPACITEPERM(state, payload) {
		state.prevoyance.typeConjointCollectifIncapacitePerm = payload;
	},
	SET_PREVOYANCE_TYPECLIENTINDIVINCAPACITEPERMCAT(state, payload) {
		state.prevoyance.typeClientIndivIncapacitePermCat = payload;
	},
	SET_PREVOYANCE_TYPECLIENTCOLLECTIFINCAPACITEPERMCAT(state, payload) {
		state.prevoyance.typeClientCollectifIncapacitePermCat = payload;
	},
	SET_PREVOYANCE_TYPECONJOINTINDIVINCAPACITEPERMCAT(state, payload) {
		state.prevoyance.typeConjointIndivIncapacitePermCat = payload;
	},
	SET_PREVOYANCE_TYPECONJOINTCOLLECTIFINCAPACITEPERMCAT(state, payload) {
		state.prevoyance.typeConjointCollectifIncapacitePermCat = payload;
	},
	SET_PREVOYANCE_DEPENDANCE_RENTEMENSUELLECLIENT(state, payload) {
		state.prevoyance.renteMensuelleClient = payload;
	},
	SET_PREVOYANCE_DEPENDANCE_RENTEMENSUELLECONJOINT(state, payload) {
		state.prevoyance.renteMensuelleConjoint = payload;
	},
	SET_RESIDENCEFISCALE_ADRESSEFISCALESAME(state, payload) {
		state.residenceFiscale.adresseFiscaleSame = payload;
	},
	SET_RESIDENCEFISCALE_CONTACTINFO_ADDRESS(state, payload) {
		state.residenceFiscale.contactInfo.address = payload;
	},
	SET_RESIDENCEFISCALE_CONTACTINFO_ADDRESSCOMP(state, payload) {
		state.residenceFiscale.contactInfo.addressComp = payload;
	},
	SET_RESIDENCEFISCALE_CONTACTINFO_ZIPCODE(state, payload) {
		state.residenceFiscale.contactInfo.zipCode = payload;
	},
	SET_RESIDENCEFISCALE_CONTACTINFO_CITY(state, payload) {
		state.residenceFiscale.contactInfo.city = payload;
	},
	SET_RESIDENCEFISCALE_CONTACTINFO_COUNTRY(state, payload) {
		state.residenceFiscale.contactInfo.country = payload;
	},
	SET_CONJOINT_RESIDENCEFISCALE_ADRESSEFISCALESAME(state, payload) {
		state.situationFamiliale.conjointResidenceFiscale.adresseFiscaleSame = payload;
	},
	SET_CONJOINT_RESIDENCEFISCALE_CONTACTINFO_ADDRESS(state, payload) {
		state.situationFamiliale.conjointResidenceFiscale.contactInfo.address = payload;
	},
	SET_CONJOINT_RESIDENCEFISCALE_CONTACTINFO_ADDRESSCOMP(state, payload) {
		state.situationFamiliale.conjointResidenceFiscale.contactInfo.addressComp = payload;
	},
	SET_CONJOINT_RESIDENCEFISCALE_CONTACTINFO_ZIPCODE(state, payload) {
		state.situationFamiliale.conjointResidenceFiscale.contactInfo.zipCode = payload;
	},
	SET_CONJOINT_RESIDENCEFISCALE_CONTACTINFO_CITY(state, payload) {
		state.situationFamiliale.conjointResidenceFiscale.contactInfo.city = payload;
	},
	SET_CONJOINT_RESIDENCEFISCALE_CONTACTINFO_COUNTRY(state, payload) {
		state.situationFamiliale.conjointResidenceFiscale.contactInfo.country = payload;
	},
	SET_RECUEIL(state, payload) {
		//state.etatCivil.firstName = payload.data.etatCivil.firstName;
		state.hasChanges = { steps: []}//false;
		state.clientId = payload.clientId;
		state.alias = payload.alias;
		state.etatCivil = payload.etatCivil;
		state.contactInfo = payload.contactInfo;
		state.situationProfessionnelle = payload.situationProfessionnelle;
		state.commentaireDossier = payload.commentaireDossier;
		state.derDossier = payload.derDossier;
		state.fiscalite.irppAcquitte = payload.irppAcquitte + " €";
		state.fiscalite.ifiAcquitte = payload.ifiAcquitte + " €";
		if (payload.conformite) {
			state.conformite = {
				origineFonds: payload.conformite.origineFonds || [],
				objetRelation: payload.conformite.objetRelation || [],
				coherenceProfil: payload.conformite.coherenceProfil != null ? String(payload.conformite.coherenceProfil) : null,
				clientPresentRdv: payload.conformite.clientPresentRdv,
			};
		} else {
			state.conformite = { origineFonds: [], objetRelation: [], coherenceProfil: null, clientPresentRdv: null };
		}
		if (payload.residenceFiscale) {
			state.residenceFiscale = payload.residenceFiscale;
			if (!payload.residenceFiscale.contactInfo) {
				state.residenceFiscale.contactInfo = {
					address: "",
					addressComp: "",
					zipCode: "",
					city: "",
					country: "",
				};
			}
		} else {
			state.residenceFiscale = {
				adresseFiscaleSame: true,
				contactInfo: {
					address: "",
					addressComp: "",
					zipCode: "",
					city: "",
					country: "",
				}
			};
		}
		if (payload.situationFamiliale) {
			state.situationFamiliale.famSituation = payload.situationFamiliale.famSituation;
			state.situationFamiliale.regimeMatrimonial = payload.situationFamiliale.regimeMatrimonial;
			state.situationFamiliale.regimePacs = payload.situationFamiliale.regimePacs;
			state.situationFamiliale.hasConjoint = payload.situationFamiliale.hasConjoint;
			state.situationFamiliale.hasRegimeMatrimonial = payload.situationFamiliale.hasRegimeMatrimonial;
			state.situationFamiliale.hasRegimePacs = payload.situationFamiliale.hasRegimePacs;
			if (payload.situationFamiliale.conjointEtatCivil)
				state.situationFamiliale.conjointEtatCivil = payload.situationFamiliale.conjointEtatCivil;
			else {
				state.situationFamiliale.conjointEtatCivil = {
					civility: "",
					firstName: "",
					lastName: "",
					birthLastName: "",
					dateOfBirth: "",
					birthCity: "",
					birthState: "",
					birthDeptNum: "",
					birthCountry: "",
					nationality: "",
					isAncienCombattant: false,
					isHandicape: false,
				};
			}
			if (payload.situationFamiliale.conjointSituationProfessionnelle)
				state.situationFamiliale.conjointSituationProfessionnelle = payload.situationFamiliale.conjointSituationProfessionnelle;
			else {
				state.situationFamiliale.conjointSituationProfessionnelle = {
					socioProCat: "",
					libelle: ""
				};
			}
			if (payload.situationFamiliale.conjointContactInfo)
				state.situationFamiliale.conjointContactInfo = payload.situationFamiliale.conjointContactInfo;
			else {
				state.situationFamiliale.conjointContactInfo = {
					proEmail: "",
					persoEmail: "",
					persoPhone: "",
					proPhone: "",
					cellPhone: "",
					persoPhoneFormatted: "",
					cellPhoneFormatted: "",
					proPhoneFormatted: "",
					persoPhoneCountryVal: "FR",
					cellPhoneCountryVal: "FR",
					proPhoneCountryVal: "FR",
				};
			}
		} else {
			state.situationFamiliale = {
				famSituation: "",
				regimeMatrimonial: "",
				regimePacs: "",
				hasConjoint: false,
				hasRegimeMatrimonial: false,
				hasRegimePacs: false,
				conjointEtatCivil: {
					civility: "",
					firstName: "",
					lastName: "",
					birthLastName: "",
					dateOfBirth: "",
					birthCity: "",
					birthState: "",
					birthDeptNum: "",
					birthCountry: "",
					nationality: "",
					isAncienCombattant: false,
					isHandicape: false,
				},
				conjointSituationProfessionnelle: {
					socioProCat: "",
					libelle: ""
				},
				conjointContactInfo: {
					proEmail: "",
					persoEmail: "",
					persoPhone: "",
					proPhone: "",
					cellPhone: "",
					persoPhoneFormatted: "",
					cellPhoneFormatted: "",
					proPhoneFormatted: "",
					persoPhoneCountryVal: "FR",
					cellPhoneCountryVal: "FR",
					proPhoneCountryVal: "FR",
				}
			};
		}
		if (payload.avantagesMatrimoniaux2)
			state.avantagesMatrimoniaux = payload.avantagesMatrimoniaux2;
		else {
			state.avantagesMatrimoniaux = {
				attributionBiensCommuns: null,
				auProfitClientAssuranceNonDenouees: "1",
				auProfitConjointAssuranceNonDenouees: "1",
				montantAuProfitClientAssuranceNonDenouees: 0,
				montantAuProfitConjointAssuranceNonDenouees: 0,
				autresBiensClient: null,
				autresBiensConjoint: null,
				avantagesMatrimoniauxCommentaires: "",
				isClausePreciputAuProfitClient: false,
				isClausePreciputAuProfitConjoint: false,
				auProfitClientDonationDernierVivant: false,
				auProfitConjointDonationDernierVivant: false,
				auProfitClientDonationsEntreVifs: 0,
				auProfitConjointDonationsEntreVifs: 0,
				duesParClientBeneficeCommunaute: 0,
				duesParConjointBeneficeCommunaute: 0,
				duesParCommunauteAuClient: 0,
				duesParCommunauteAuConjoint: 0,
				auProfitClientDonationAnterieur: 0,
				auProfitConjointDonationAnterieur: 0,
				auProfitClientLegs: "1",
				auProfitClientLegsMontant: 0,
				auProfitClientLegsUsurfruit: false,
				auProfitConjointLegs: "1",
				auProfitConjointLegsMontant: 0,
				auProfitConjointLegsUsurfruit: false,
				dettesClientEnversConjoint: 0,
				dettesConjointEnversClient: 0,
				auProfitClientCreanceParticipation: 0,
				auProfitConjointCreanceParticipation: 0,
			};
		}
		if (payload.heritiers)
			state.heritiers = payload.heritiers;
		else {
			state.heritiers = [];
		}
		if (payload.liberalites)
			state.liberalites = payload.liberalites;
		else {
			state.liberalites = [];
		}
		if (payload.actifs) {
			state.actifs = payload.actifs;
		} else {
			state.actifs = [];
		}
		if (payload.passifs)
			state.passifs = payload.passifs;
		else {
			state.passifs = [];
		}
		if (payload.revenus)
			state.revenus = payload.revenus;
		else {
			state.revenus = [];
		}
		if (payload.charges)
			state.charges = payload.charges;
		else {
			state.charges = [];
		}
		if (payload.objectifs)
			state.objectifs = payload.objectifs;
		else {
			state.objectifs = [];
		}
		if (payload.prevoyanceDossier2) {
			//state.prevoyance = payload.prevoyance;

			state.prevoyance.typeClientIndivIncapaciteTemp = payload.prevoyanceDossier2.typeClientIndivIncapaciteTemp;
			state.prevoyance.typeClientCollectifIncapaciteTemp = payload.prevoyanceDossier2.typeClientCollectifIncapaciteTemp;
			state.prevoyance.typeConjointIndivIncapaciteTemp = payload.prevoyanceDossier2.typeConjointIndivIncapaciteTemp;
			state.prevoyance.typeConjointCollectifIncapaciteTemp = payload.prevoyanceDossier2.typeConjointCollectifIncapaciteTemp;

			state.prevoyance.typeClientIndivIncapacitePerm = payload.prevoyanceDossier2.typeClientIndivIncapacitePerm;
			state.prevoyance.typeClientCollectifIncapacitePerm = payload.prevoyanceDossier2.typeClientCollectifIncapacitePerm;
			state.prevoyance.typeConjointIndivIncapacitePerm = payload.prevoyanceDossier2.typeConjointIndivIncapacitePerm;
			state.prevoyance.typeConjointCollectifIncapacitePerm = payload.prevoyanceDossier2.typeConjointCollectifIncapacitePerm;

			state.prevoyance.typeClientIndivIncapacitePermCat = payload.prevoyanceDossier2.typeClientIndivIncapacitePermCat;
			state.prevoyance.typeClientCollectifIncapacitePermCat = payload.prevoyanceDossier2.typeClientCollectifIncapacitePermCat;
			state.prevoyance.typeConjointIndivIncapacitePermCat = payload.prevoyanceDossier2.typeConjointIndivIncapacitePermCat;
			state.prevoyance.typeConjointCollectifIncapacitePermCat = payload.prevoyanceDossier2.typeConjointCollectifIncapacitePermCat;
			state.prevoyance.renteMensuelleClient = payload.prevoyanceDossier2.renteMensuelleClient;
			state.prevoyance.renteMensuelleConjoint = payload.prevoyanceDossier2.renteMensuelleConjoint;
		} else {
			state.prevoyance = {
				typeClientIndivIncapaciteTemp: "",
				typeClientCollectifIncapaciteTemp: "",
				typeConjointIndivIncapaciteTemp: "",
				typeConjointCollectifIncapaciteTemp: "",

				typeClientIndivIncapacitePerm: "",
				typeClientCollectifIncapacitePerm: "",
				typeConjointIndivIncapacitePerm: "",
				typeConjointCollectifIncapacitePerm: "",

				typeClientIndivIncapacitePermCat: "",
				typeClientCollectifIncapacitePermCat: "",
				typeConjointIndivIncapacitePermCat: "",
				typeConjointCollectifIncapacitePermCat: "",
				renteMensuelleClient: 0,
				renteMensuelleConjoint: 0,
			};
		}
		if (payload.deces)
			state.prevoyance.deces = payload.deces;
		else {
			state.prevoyance.deces = [];
		}
		if (payload.incapaciteTemp)
			state.prevoyance.incapaciteTemp = payload.incapaciteTemp;
		else {
			state.prevoyance.incapaciteTemp = [];
		}
		if (payload.incapacitePerm)
			state.prevoyance.incapacitePerm = payload.incapacitePerm;
		else {
			state.prevoyance.incapacitePerm = [];
		}

	},	
	RESET_STATE(state){
		state.clientId = "";
		state.dossierId = "";
		state.commentaireDossier = "";
		state.derDossier = "";
		state.alias = "";
		state.etatCivil = {
			civility: "",
			firstName: "",
			lastName: "",
			birthLastName: "",
			dateOfBirth: "",
			birthCity: "",
			birthState: "",
			birthDeptNum: "",
			birthCountry: "",
			nationality: "",
			isParentIsole: false,
			isAncienCombattant: false,
			isHandicape: false,
		};
		state.contactInfo = {
			address: "",
			addressComp: "",
			zipCode: "",
			city: "",
			country: "",
			proEmail: "",
			persoEmail: "",
			persoPhone: "",
			proPhone: "",
			cellPhone: "",
			persoPhoneFormatted: "",
			cellPhoneFormatted: "",
			proPhoneFormatted: "",
			persoPhoneCountryVal: "FR",
			cellPhoneCountryVal: "FR",
			proPhoneCountryVal: "FR",
		};
		state.situationProfessionnelle = {
			socioProCat: "",
			libelle: ""
		};
		state.residenceFiscale = {
			adresseFiscaleSame: true,
			contactInfo: {
				address: "",
				addressComp: "",
				zipCode: "",
				city: "",
				country: "",
			}
		};
		state.situationFamiliale = {
			famSituation: "",
			regimeMatrimonial: "",
			regimePacs: "",
			hasConjoint: false,
			hasRegimeMatrimonial: false,
			hasRegimePacs: false,
			conjointEtatCivil: {
			civility: null,
			firstName: "",
			lastName: "",
			birthLastName: "",
			dateOfBirth: "",
			birthCity: "",
			birthState: "",
			birthDeptNum: "",
			birthCountry: "",
			nationality: "",
			isAncienCombattant: false,
			isHandicape: false,
			},
			conjointSituationProfessionnelle: {
				socioProCat: "",
				libelle: ""
			},
			conjointContactInfo: {
				proEmail: "",
				persoEmail: "",
				persoPhone: "",
				proPhone: "",
				cellPhone: "",
				persoPhoneFormatted: "",
				cellPhoneFormatted: "",
				proPhoneFormatted: "",
				persoPhoneCountryVal: "FR",
				cellPhoneCountryVal: "FR",
				proPhoneCountryVal: "FR",
			},
			conjointResidenceFiscale: {
				adresseFiscaleSame: true,
				contactInfo: {
					address: "",
					addressComp: "",
					zipCode: "",
					city: "",
					country: "",
				}
			},
		};
		state.fiscalite = {
			irppAcquitte: 0,
			ifiAcquitte: 0
		};
		state.avantagesMatrimoniaux = {
			attributionBiensCommuns: null,
			auProfitClientAssuranceNonDenouees: "1",
			auProfitConjointAssuranceNonDenouees: "1",
			montantAuProfitClientAssuranceNonDenouees: 0,
			montantAuProfitConjointAssuranceNonDenouees: 0,
			autresBiensClient: null,
			autresBiensConjoint: null,
			avantagesMatrimoniauxCommentaires: "",
			isClausePreciputAuProfitClient: false,
			isClausePreciputAuProfitConjoint: false,
			auProfitClientDonationDernierVivant: false,
			auProfitConjointDonationDernierVivant: false,
			auProfitClientDonationsEntreVifs: 0,
			auProfitConjointDonationsEntreVifs: 0,
			duesParClientBeneficeCommunaute: 0,
			duesParConjointBeneficeCommunaute: 0,
			duesParCommunauteAuClient: 0,
			duesParCommunauteAuConjoint: 0,
			auProfitClientDonationAnterieur: 0,
			auProfitConjointDonationAnterieur: 0,
			auProfitClientLegs: "1",
			auProfitClientLegsMontant: 0,
			auProfitClientLegsUsurfruit: false,
			auProfitConjointLegs: "1",
			auProfitConjointLegsMontant: 0,
			auProfitConjointLegsUsurfruit: false,
			dettesClientEnversConjoint: 0,
			dettesConjointEnversClient: 0,
			auProfitClientCreanceParticipation: 0,
			auProfitConjointCreanceParticipation: 0,
		};
		state.heritiers = [{}];
		state.liberalites = [];
		state.actifs = [];
		state.passifs = [];
		state.revenus = [];
		state.charges = [];
		state.objectifs = [];
		state.prevoyance = {
			typeClientIndivIncapaciteTemp: "",
			typeClientCollectifIncapaciteTemp: "",
			typeConjointIndivIncapaciteTemp: "",
			typeConjointCollectifIncapaciteTemp: "",
		
			typeClientIndivIncapacitePerm: "",
			typeClientCollectifIncapacitePerm: "",
			typeConjointIndivIncapacitePerm: "",
			typeConjointCollectifIncapacitePerm: "",
		
			typeClientIndivIncapacitePermCat: "",
			typeClientCollectifIncapacitePermCat: "",
			typeConjointIndivIncapacitePermCat: "",
			typeConjointCollectifIncapacitePermCat: "",
			renteMensuelleClient: 0,
			renteMensuelleConjoint: 0,
			deces: [],
			incapaciteTemp: [],
			incapacitePerm: []
		};
	},
};